module.exports = __webpack_public_path__ + "static/media/main-bg.5813082e.png";